// Default grace window (minutes) applied before a shift starts and after it
// ends when deciding whether it counts as "current". Keeps a shift visible a
// little early and a little late instead of snapping exactly to its bounds.
export const SHIFT_WINDOW_BUFFER_MINUTES = 30

// Feathers query fragment matching shifts relevant at `now`: ongoing, or
// within `bufferMinutes` of their start/end. Spread into a query alongside
// any other filters (assignedStaffIds, $sort, $limit, …).
//
// A shift overlaps the window when it starts on/before now+buffer AND ends
// on/after now-buffer — a single condition, no $or needed. (The old code
// used a two-branch $or whose second branch was a subset of the first, so
// the buffer never actually applied and the cutoff was exact.)
export const shiftWindowQuery = (
  now: number,
  bufferMinutes: number = SHIFT_WINDOW_BUFFER_MINUTES,
) => {
  const buffer = bufferMinutes * 60_000

  return {
    startsAt: { $lte: now + buffer },
    endsAt: { $gte: now - buffer },
  }
}
